import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "18",
  viewBox: "0 0 20 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.38445 1.49956C8.54724 -0.499853 11.4528 -0.499853 12.6156 1.49956L19.5906 13.4996C20.7536 15.4993 19.3005 17.9998 16.975 17.9998H3.02497C0.699554 17.9998 -0.75346 15.4995 0.409303 13.4998L7.38445 1.49956ZM10 5.99975C10.556 5.99975 11.0068 6.44747 11.0068 6.99975V8.99975C11.0068 9.55204 10.556 9.99975 10 9.99975C9.44397 9.99975 8.99321 9.55204 8.99321 8.99975V6.99975C8.99321 6.44747 9.44397 5.99975 10 5.99975ZM8.99321 12.9998C8.99321 12.4475 9.44397 11.9998 10 11.9998H10.0101C10.5661 11.9998 11.0169 12.4475 11.0169 12.9998C11.0169 13.552 10.5661 13.9998 10.0101 13.9998H10C9.44397 13.9998 8.99321 13.552 8.99321 12.9998Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}